
import React from "react";
import { VariantMeasurementManager } from "@/components/variant-measurements/VariantMeasurementManager";

export default function VariantMeasurements() {
  return (
    <div className="container mx-auto px-4 py-6">
      <VariantMeasurementManager />
    </div>
  );
}
